import { PERMISSIONS, RESULTS, checkNotifications, request, requestMultiple } from "react-native-permissions";
import { showDialog } from "../components/CommonDialog";
import {
    Str_AlbumPermissionErrorTip,
    Str_CameraPermissionErrorTip,
    Str_MicPermissionErrorTip,
    Str_WriteFilePermissionErrorTip,
} from "../language/string_res";
import { isIos } from "../AppEvent";
import { Linking,  Platform } from "react-native";

export async function checkNotifice(callback: (b: boolean) => void) {
    checkNotifications().then((r) => {
        callback(r.status === "granted");
    });
}

async function requestNotificationPermission() {
   
}

// Web 版本：移除相机权限申请
export const requestCameraPermission = ({ suc }: { suc: () => void; fail?: () => void }) => {
    console.warn('requestCameraPermission not supported on web');
    fail?.();
};

export const cameraRequest = ({ suc }: { suc: () => void; fail?: () => void }) => {
    console.warn('cameraRequest not supported on web');
    fail?.();
};

export const requestCamera = async (): Promise<boolean> => {
    console.warn('requestCamera not supported on web');
    return false;
};

export const requestAudio = ({ suc, fail }: { suc: () => void; fail?: () => void }) => {
    if (Platform.OS === "ios") {
        request(PERMISSIONS.IOS.MICROPHONE)
            .then((res) => {
                if (res === "granted") {
                    suc();
                } else {
                    fail?.();
                    showFailDialog(Str_MicPermissionErrorTip);
                }
            })
            .catch(() => {
                fail?.();
                showFailDialog(Str_MicPermissionErrorTip);
            });
    } else if (Platform.OS === "android") {
        request(PERMISSIONS.ANDROID.RECORD_AUDIO)
            .then((r) => {
                if (r === "granted") {
                    suc();
                } else {
                    fail?.();
                    showFailDialog(Str_MicPermissionErrorTip);
                }
            })
            .catch(() => {
                fail?.();
                showFailDialog(Str_MicPermissionErrorTip);
            });
    }
};

function showFailDialog(msg: string) {
    showDialog({
        message: msg,
        onCancel:()=>{},
        onConfirm: () => {
            if (Platform.OS === "android") {
                Linking.openSettings();
            } else {
                Linking.openURL("app-settings:");
            }
        },
    });
}

// Web 版本：移除相册权限申请
export async function requestImage(): Promise<boolean> {
    console.warn('requestImage not supported on web');
    return false;
}
